<template>
  <sidebar @close="close">
    <template v-slot:head>
      <div class="container has-text-centered">
        <img width="96" height="96" :src="img"/>
        <h2 class="title is-4">
          SMS OTP
        </h2>
      </div>
    </template>
    <template v-slot:body>
      <div class="container has-text-centered">
        <card>
          <card-header :title="$t('profile.mobile_phone_label')">
          </card-header>
          <card-content>
            <fieldset :disabled="!edit">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('profile.mobile_phone')"
                    value=""
                    v-model="editSms.phone"
                  />
                </div>
              </div>
            </fieldset>
            <phone-verification-status :isVerified="sms.verified" ></phone-verification-status>
          </card-content>
          <card-footer v-if="edit">
            <a class="card-footer-item" @click="save()">{{ $t('editing.save') }}</a>
            <a class="card-footer-item" @click="endEdit()">{{ $t('editing.cancel') }}</a>
          </card-footer>
        </card>
        <br/>
        <template v-if="canVerify">
          <div class="field">
            <div class="control">
              <input
                class="input"
                type="text"
                :placeholder="$t('auth_factors.one_time_password')"
                value=""
                v-model="passcode"
              />
            </div>
            <p class="help is-danger has-text-left" v-if="invalid">{{ error }}</p>
          </div>
          <div class="button is-link is-fullwidth" @click="verify">
            <span>{{ $t('auth_factors.verify') }}</span>
          </div>
        </template>
      </div>
    </template>
    <template v-slot:foot>
      <div class="container has-text-centered"  v-if="canVerify">
        <a @click="sendCode" v-if="!isRunning">{{ $t('auth_factors.send_code') }}</a>
        <Timer :ticker="prettyTime" v-else></Timer>
      </div>
    </template>
  </sidebar>
</template>

<script>
import profile from "@/services/profile";
import sms from "@/services/sms";
import Sidebar from "@/components/Sidebar";
import Timer from "@/components/Timer";
import PhoneVerificationStatus from "@/components/PhoneVerificationStatus";

export default {
  name: "SmsDetails",
  components: {
    Sidebar,
    Timer,
    PhoneVerificationStatus
  },
  props: {
    sms: {
      required: true
    },
    img: {
      required: true
    }
  },
  data() {
    return {
      passcode: "",
      error: "",
      invalid: false,
      edit: false,
      editSms: this.sms,
      isRunning: false,
      timer: null,
      ticker: 0,
      startTime: 60
    };
  },
  computed: {
    prettyTime() {
      if (this.ticker < 60) {
        let t = parseInt(this.ticker);
        return parseInt(0) + ":" + t;
      }
      let time = this.ticker / 60;
      let minutes = parseInt(time);
      let secondes = Math.round((time - minutes) * 60);
      return minutes + ":" + secondes;
    },
    canVerify() {
      return !!this.sms && !this.sms.verified;
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    close() {
      this.passcode = "";
      this.error = "";
      this.invalid = false;
      this.edit = false;
      this.$emit("close");
    },
    getStartTime() {
      sms.getStartTime().then(
        (response) => {
          this.startTime = this.ticker = response.data.Timing
        },
        err => {
          console.log(err);
          this.startTime = this.ticker = 60
        }
      );
    },
    verify() {
      sms.verifyCode(this.passcode).then(
        () => {
          this.invalid = false;
          this.error = "";
          this.close();
        },
        err => {
          this.invalid = true;
          this.error = this.$i18n.t('auth_factors.wrong_code');
          console.log(err);
        }
      );
    },
    save() {
      profile.savePhone(this.editSms.phone).then(
        () => {
          this.invalid = false;
          this.error = "";
        },
        err => {
          console.log(err);
        }
      );
      this.endEdit();
    },
    sendCode() {
      this.getStartTime();
      sms.sendCode().then(
        () => {
          this.start();
        },
        err => {
          console.log(err);
        }
      );
    },
    beginEdit() {
      this.edit = true;
    },
    endEdit() {
      this.edit = false;
    },
    stop() {
      this.isRunning = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    reset() {
      this.stop();
      this.ticker = 0;
    },
    start() {
      this.isRunning = true;
      this.ticker = this.startTime;
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.ticker > 0) {
            this.ticker--;
          } else {
            clearInterval(this.timer);
            this.reset();
          }
        }, 1000);
      }
    }
  },
};
</script>
